import { render } from "./OAuth.vue?vue&type=template&id=3b79834c&scoped=true"
import script from "./OAuth.vue?vue&type=script&lang=js"
export * from "./OAuth.vue?vue&type=script&lang=js"

import "./OAuth.vue?vue&type=style&index=0&id=3b79834c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b79834c"]])

export default __exports__